import React from "react";
import { SEO, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class BookNowPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.marktaylorsalon.com/book-now/"}
        />
        <Grid
          className={"custom-page-booking custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"jdoecfeaholneplj"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"lhbbijnbpnkkendc"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__3c166ee7-8427-45bf-9c74-9d68bbc15aa5"}
                >
                  <div>
                    <div
                      id={"frameTitle"}
                      className={"embedded-widget-title"}
                    />
                    <div className={"vagaro"}>
                      <DynamicScript
                        src={
                          "https://www.vagaro.com//resources/WidgetEmbeddedLoader/OZqtCJ4vDoPqFJ1y6BuPlXiz3avV34mC2PeFJ4mC30m9cyUeJUtjP0dDxkJEvwRapWUgZawifCs7fcJEPwMc8?v=MudneecpZzyNDt59yXtHzYENKVgAxh4g0SC8QBRMFisG#"
                        }
                        delay={100}
                      />
                    </div>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 34662 }) {
      title
      seoTitle
      description
    }
  }
`;
